<template>
  <v-list-item @click="open">
    <v-list-item-avatar>
      <v-icon small>fal fa-globe-asia</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>オンライン設定</v-list-item-content>
    <v-dialog class="author-toolkit" v-model="config.status.active" max-width="600px">
      <v-card>
        <v-card-title class="primary blue-grey--text text--darken-4">
          <span class="headline">オンライン設定</span>
        </v-card-title>
        <v-card-text>
          <v-window v-model="config.page">
            <v-window-item value="main">
              <v-progress-linear v-if="isInitializaing" :indeterminate="true" color="blue darken-2"></v-progress-linear>
              <v-container grid-list-md v-else>
                <v-row dense>
                  <v-col cols="10">
                    <v-text-field v-if="isSetOnline" readonly
                      v-model="printOnlineUrl"
                      :label="printOnlineStatus"
                    />
                    <p v-else class="body-1">オンラインの設定が必要です。</p>
                  </v-col>
                  <v-col cols="2" v-if="isSetOnline" align-self="center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on" color="secondary" @click.stop="copyUrl">
                          <v-icon small>fa-copy</v-icon>
                        </v-btn>
                      </template>
                      <span>クリップボードにコピー</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="10" v-if="isSetOnline">
                    <v-select
                      v-model="store.email"
                      :items="getContacts"
                      label="ログイン情報をメール送信します"
                    />
                  </v-col>
                  <v-col cols="2" v-if="isSetOnline" align-self="center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn icon
                          v-on="on"
                          color="secondary"
                          :loading="isLoading"
                          @click.stop="invite"
                        >
                          <v-icon small>fa-paper-plane</v-icon>
                        </v-btn>
                      </template>
                      <span>メールを送る</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12">
                    <v-btn text
                      color="secondary"
                      @click.stop="openSetter">
                      <v-icon small>fa-cog</v-icon>&nbsp;{{ isSetOnline ? '設定を変更する' : '設定を始める' }}
                    </v-btn>
                  </v-col>
                </v-row>
            </v-container>
          </v-window-item>
          <v-window-item value="setter">
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-container grid-list-md>
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field required
                      v-model="form.auth.id"
                      label="ログインID"
                      :rules="rules.id"
                    />
                  </v-col>
                  <v-col cols="12" v-if="form.id !== ''">
                    <v-switch
                      color="blue darken-2"
                      v-model="form.isUpdateStatus"
                      label="パスワードを変更する"
                      @change="form.auth.passwd = ''"
                    />
                  </v-col>
                  <v-col cols="12" v-if="form.isUpdateStatus || form.id === ''">
                    <v-text-field required
                      v-model="form.auth.passwd"
                      label="パスワード"
                      :rules="rules.passwd"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-window-item>
          </v-window>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn v-if="config.page === 'main'" text color="secondary" @click="close">閉じる</v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="config.page === 'setter'"  text color="secondary" @click="closeSetter">止める</v-btn>
          <v-btn depressed
            v-if="config.page === 'setter'"
            color="blue darken-2 white--text"
            :disabled="!this.form.valid"
            :loading="isLoading"
            @click.stop="submit"
          >保存する</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-item>
</template>

<script>
import copy from 'clipboard-copy'
export default {
  name: 'client-online',
  data () {
    return {
      config: {
        status: {
          active: false,
          initializing: true,
          loading: false
        },
        page: 'main'
      },
      meta: {
        status: {
          active: 'オンラインは有効です',
          cancel: 'オンラインはロックされています'
        }
      },
      form: {
        id: '',
        token: '',
        auth: {
          id: '',
          passwd: ''
        },
        status: '',
        isUpdateStatus: false
      },
      rules: {
        id: [
          v => !!v || '必須項目です'
        ],
        passwd: [
          v => !!v || '必須項目です'
        ]
      },
      store: {
        id: '',
        token: '',
        auth: {
          id: '',
          passwd: ''
        },
        status: '',
        email: '',
        contacts: []
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this.config, 'page', 'main')
      this.$set(this.config.status, 'initializing', true)
      this.$set(this.config.status, 'active', true)
      this.$firebase.auth().currentUser.getIdToken(true)
        .then(this.getPromised)
        .then(this.searchContactsPromised)
        .then(() => {
          this.$set(this.config.status, 'initializing', false)
          this.$set(this.config.status, 'loading', false)
        })
    },
    get: function () {
      this.$firebase.auth().currentUser.getIdToken(true)
        .then(this.getPromised)
        .then(() => {
          this.$set(this.config.status, 'loading', false)
        })
    },
    getPromised: function (fbToken) {
      return new Promise((resolve, reject) => {
        this.axios.post(this.$url.api + 'client/get/login', {
          cid: this.$route.params.id
        }, {
          headers: {
            'firebase-token': fbToken
          }
        }).then(res => {
          console.log(res)
          if (res.data && res.data.success) {
            const { id, token, auth, status } = res.data.data
            this.$set(this, 'form', {
              valid: true,
              id: id,
              token: token,
              auth: {
                id: auth.id,
                passwd: auth.passwd
              },
              status: status,
              isUpdateStatus: false
            })
            this.$set(this, 'store', {
              id: id,
              token: token,
              auth: {
                id: auth.id,
                passwd: auth.passwd
              },
              status: status
            })
            resolve(fbToken)
          } else {
            reject(res)
          }
        })
      })
    },
    searchContacts: function () {
      this.$firebase.auth().currentUser.getIdToken(true)
        .then(this.searchContactsPromised)
        .then(() => {
          this.$set(this.config.status, 'loading', false)
        })
    },
    searchContactsPromised: function (fbToken) {
      return new Promise((resolve, reject) => {
        this.axios.post(this.$url.api + 'about/linked/search/contact', {
          cid: this.$route.params.id
        }, {
          headers: {
            'firebase-token': fbToken
          }
        }).then(res => {
          console.log(res)
          if (res.data && res.data.success) {
            const emails = res.data.data.filter(it => {
              return it.type && it.type === 'email'
            })
            this.$set(this.store, 'email', emails.length ? emails[0].contact : '')
            this.$set(this.store, 'contacts', emails)
            resolve(fbToken)
          } else {
            reject(res)
          }
        })
      })
    },
    open: function () {
      this.init()
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
      this.$emit('close')
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'client/update/login', {
            id: this.form.id,
            cid: this.$route.params.id,
            form: {
              id: this.form.auth.id,
              passwd: (!this.form.id || this.form.isUpdateStatus) ? this.form.auth.passwd : '',
              status: this.form.status
            }
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.close()
            }
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    invite: function () {
      if (this.store.email) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'mail/invite/online', {
            cid: this.$route.params.id,
            email: this.store.email
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    openSetter: function () {
      const { id, token, auth, status } = this.store
      this.$set(this, 'form', {
        valid: true,
        id: id,
        token: token,
        auth: {
          id: auth.id,
          passwd: auth.passwd
        },
        status: status,
        isUpdateStatus: false
      })
      this.$set(this.config, 'page', 'setter')
    },
    closeSetter: function () {
      this.$set(this.config, 'page', 'main')
    },
    copyUrl: function () {
      const { token } = this.form
      if (token) {
        copy(`${this.$url.client}login?t=${token}`).then(() => {
          this.$store.dispatch('notifier/addSSuccess', {
            title: 'クリップボードへコピー',
            message: 'URLをコピーしました'
          })
        })
      }
    }
  },
  computed: {
    isSubmittable () {
      return this.$store.getters['client/get']('author').id !== this.form.author.to
    },
    isInitializaing () {
      return this.config.status.initializing
    },
    isLoading () {
      return this.config.status.loading
    },
    isSetOnline () {
      return (this.form.status && this.meta.status[this.form.status])
    },
    getContacts () {
      return this.store.contacts ? this.store.contacts.map(it => {
        return it.contact
      }) : []
    },
    printOnlineUrl () {
      return this.form.token ? this.$url.client + 'login?t=' + this.form.token : ''
    },
    printOnlineStatus () {
      return (this.form.status && this.meta.status[this.form.status]) ? this.meta.status[this.form.status] : 'オンラインの設定が必要です'
    }
  }
}
</script>

<style lang="scss">
.author-toolkit {
  .app {
    position: relative;
    .label {
      position: absolute;
      bottom: -2em;
      left: 0;
      display: block;
    }
  }
}
</style>
